<template>
    <div class="cont-table">

        <div class="spin">
            <ion-spinner name="crescent"></ion-spinner>
        </div>

        <div class="row cont_ticket_res_ok">
            <div class=" " style="margin:0 auto;">
                <div class="card">

                    <div class="card-body" style="padding:0px">

                        <div class="table-responsive" style="">

                            <table id="myTable" style="margin-top:57px">
                                <thead>
                                    <tr>

                                        <th class='all'>
                                            <div class="cl_checkall">
                                                <ion-checkbox name='emailgestoreall' class='checkall' slot='start'
                                                    style="width:10px!important;height:10px!important">
                                                </ion-checkbox>
                                            </div>
                                        </th>

                                        <th class='all'>
                                            <div style="margin-right: 22px;">N.</div>
                                        </th>
                                        <th class='all'>Cognome</th>
                                        <th class='all'>Nome</th>
                                        <th class='all' style="text-align:center">Stato</th>
                                        <th class='all' style="text-align:center">
                                            <div style="margin-left: 14px;">Giornate</div>
                                        </th>
                                        <th class='all' style="text-align:center">
                                            <div style="margin-left: 17px;">Ticket</div> 
                                        </th>
                                        <th class='all' style="text-align:right;padding-right: 0px!important">Costo (€)</th>


                                    </tr>
                                </thead>

                                <tfoot>


                                    <tr>

                                        <th class='all col_footer'>&nbsp;</th>

                                        <th class='all col_footer'>
                                            <div class="div_n">&nbsp;</div>
                                        </th>

                                        <th class='all col_footer'>Totale (€)</th>

                                        <th class='all col_footer'>&nbsp;</th>

                                        <th class='all col_footer'>&nbsp;</th>

                                        <th class='all col_footer'>&nbsp;</th>

                                        <th class='all col_footer'>&nbsp;</th>

                                        <th class='desktop col_footer_right' id="v_tot_costo">0,00</th>



                                    </tr>




                                </tfoot>

                            </table>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="text-left">
            <v-bottom-sheet v-model="sheetChangeStatus">
                <v-sheet class="text-center" height="340px" style="padding-bottom:120px;">
                    <v-btn class='closeStatusSheet' icon @click="sheetChangeStatus = !sheetChangeStatus">
                        <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                    <div class="py-3">
                        Seleziona stato
                    </div>
                    <v-list-item v-for="tile in allStatus" :key="tile.title" @click="changeStatusAdmin(tile.title)">
                        <v-list-item-avatar>
                            <v-avatar size="32px" tile>
                                <v-icon :color="tile.color">{{ tile.icon }}</v-icon>
                            </v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-title style="justify-content: center;text-align: left;">{{
                            tile.title
                            }}</v-list-item-title>
                    </v-list-item>
                </v-sheet>
            </v-bottom-sheet>
        </div>

        <div class="text-left">
            <v-bottom-sheet v-model="sheetStatus">
                <v-sheet class="text-center" height="385px" style="padding-bottom:120px;">
                    <v-btn class='closeStatusSheet' icon @click="sheetStatus = !sheetStatus">
                        <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                    <div class="py-3">
                        Seleziona stato
                    </div>
                    <v-list-item v-for="tile in allStatusFilter" :key="tile.title" @click="changeStatus(tile.title)">
                        <v-list-item-avatar>
                            <v-avatar size="32px" tile>
                                <v-icon :color="tile.color">{{ tile.icon }}</v-icon>
                            </v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-title style="justify-content: center;text-align: left;">{{
                            tile.title
                            }}</v-list-item-title>
                    </v-list-item>
                </v-sheet>
            </v-bottom-sheet>
        </div>


        <div class="contaziende">

            <template>
                <div class="text-center">
                    <v-bottom-sheet v-model="sheetAziende" class="vaziendesheet">
                        <v-sheet class="text-center" height="100vh">
                            <div class="headerSheetAziende" fixed style="position:fixed;">
                                Aziende
                                <v-btn class='closeSheet align_close_sheet' icon @click="sheetAziende = !sheetAziende">

                                    <v-img alt="" src="@/assets/btn_cancel3_emt.png" max-width="24" max-height="24"
                                        style="margin-right:10px" />

                                </v-btn>

                                <v-toolbar>
                                    <v-text-field hide-details prepend-icon="mdi-magnify" single-line v-model="search">
                                    </v-text-field>

                                </v-toolbar>

                            </div>

                            <v-divider></v-divider>

                            <div class="spacer" style="min-height:72px;"></div>

                            <v-flex xs12 sm12>
                                <v-card>

                                    <v-list-item class="text-left" v-for="item in filteredAziende" :key="item.companyid"
                                        @click="manageClickAziende(item)">

                                        <v-img alt="" src="@/assets/aziende-emt.png" max-width="24" max-height="24" />

                                        <v-list-item-title class='itemAzienda'>{{ item.fld_name }}</v-list-item-title>

                                    </v-list-item>

                                    <div style="min-height:150px;height:150px">&nbsp;</div>

                                </v-card>
                            </v-flex>
                        </v-sheet>
                    </v-bottom-sheet>
                </div>
            </template>
        </div>

        <div class="contpopupdatefrom" style="display:none">

            <template>
                <modal name="popupDateFrom" :clickToClose="false" :width="300" :height="400">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;margin-left:10px">

                            Periodo

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important">

                            <v-menu v-model="showPicker3" :close-on-content-click="false" transitions="scale-transition"
                                offset-y max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field id="fldInpDataDa" v-model="dataDa" label="Da" persistent-hint readonly
                                        v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="dataDa" no-title @input="showPicker3 = false" locale="it">
                                </v-date-picker>
                            </v-menu>

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important">

                            <v-menu v-model="showPicker4" :close-on-content-click="false" transitions="scale-transition"
                                offset-y max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field id="fldInpDataA" v-model="dataA" label="A" persistent-hint readonly
                                        v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="dataA" no-title @input="showPicker4 = false" locale="it">
                                </v-date-picker>
                            </v-menu>

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-date-from" contain src="@/assets/btn_cancel3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Annulla" />

                                <v-img alt="" class="btn-reset-date-from" contain src="@/assets/reset.png"
                                    max-width="25" max-height="25"
                                    style="cursor:pointer;margin-right:10px;margin-top:3px"
                                    transition="scale-transition" title="Pulisci" />

                                <v-img alt="" class="btn-confirm-date-from" contain src="@/assets/btn_confirm3_emt.png"
                                    max-width="32" max-height="32" style="cursor:pointer" transition="scale-transition"
                                    title="Conferma" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>


        <div class="contpopupsearch" style="display:none">

            <template>
                <modal name="popupSearch" :clickToClose="false" :width="262" :height="215">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;margin-left:10px">

                            <v-img alt="" src="@/assets/ricerca_emt.png" max-width="25" max-height="25" />

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <v-text-field v-model="textSearch" label="">
                            </v-text-field>

                        </v-col>

                    </v-row>



                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-search" contain src="@/assets/btn_cancel3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Annulla" @click="btnCancelSearch" />

                                <v-img alt="" class="btn-delete-search" contain src="@/assets/icon_delete_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Elimina filtro" @click="btnResetSearch" />


                                <v-img alt="" class="btn-confirm-search" contain src="@/assets/btn_confirm3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer" transition="scale-transition"
                                    title="Conferma" @click="btnConfirmSearch" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>


        <div class="contpopupotpdelete" style="display:none">

            <template>
                <modal name="popupOtpDelete" :clickToClose="false" :width="262" :height="215">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;margin-left:10px">

                            Codice OTP inviatoLe via mail

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <v-text-field type="password" v-model="valueOtpDelete" label="" id="fldValueOtpDelete">
                            </v-text-field>

                        </v-col>

                    </v-row>



                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-otp-delete" contain src="@/assets/btn_cancel3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Annulla" @click="btnCancelOtpDelete" />

                                <v-img alt="" class="btn-confirm-otp-delete" contain src="@/assets/btn_confirm3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer" transition="scale-transition"
                                    title="Conferma" @click="btnConfirmOtpDelete" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>


        <div class="text-left">
            <v-bottom-sheet v-model="sheetAnni">
                <v-sheet class="text-center" height="340px" style="padding-bottom:120px;">
                    <v-btn class='closeStatusSheet' icon @click="sheetAnni = !sheetAnni">

                        <v-img alt="Proprietario Logo" style="margin-right:23px" class="  " contain
                            src="@/assets/btn_cancel3_emt.png" max-width="24" max-height="24"
                            transition="scale-transition" />

                    </v-btn>
                    <div class="py-3">
                        Anno
                    </div>
                    <v-list-item v-for="prj in anni" :key="prj.valore" @click="filterAnno(prj.valore)">
                        <v-list-item-title style="justify-content: center;text-align: left;">{{
                            prj.descrizione
                            }}</v-list-item-title>
                    </v-list-item>
                </v-sheet>
            </v-bottom-sheet>
        </div>


        <div class="text-left">
            <v-bottom-sheet v-model="sheetMesi">
                <v-sheet class="text-center" height="668px" style="padding-bottom:120px;">
                    <v-btn class='closeStatusSheet' icon @click="sheetMesi = !sheetMesi">

                        <v-img alt="Proprietario Logo" style="margin-right:23px" class="  " contain
                            src="@/assets/btn_cancel3_emt.png" max-width="24" max-height="24"
                            transition="scale-transition" />

                    </v-btn>
                    <div class="py-3">
                        Mese
                    </div>
                    <v-list-item v-for="prj in mesi" :key="prj.valore" @click="filterMese(prj.valore)">
                        <v-list-item-title style="justify-content: center;text-align: left;">{{
                            prj.descrizione
                            }}</v-list-item-title>
                    </v-list-item>
                </v-sheet>
            </v-bottom-sheet>
        </div>



        <div class="text-left">
            <v-bottom-sheet v-model="sheetFilterStatus">
                <v-sheet class="text-center" height="438px" style="padding-bottom:120px;">
                    <v-btn class='closeStatusSheet' icon @click="sheetFilterStatus = !sheetFilterStatus">

                        <v-img alt="Proprietario Logo" style="margin-right:23px" class="  " contain
                            src="@/assets/btn_cancel3_emt.png" max-width="24" max-height="24"
                            transition="scale-transition" />

                    </v-btn>
                    <div class="py-3">
                        Seleziona stato
                    </div>
                    <v-list-item v-for="tile in allFilterStatus" :key="tile.id" @click="filterStatus(tile.id)">
                        <v-list-item-avatar>
                            <v-avatar :size="tile.aSize" tile>

                                <v-img alt="" contain :src="tile.img" :max-width="tile.width"
                                    :max-height="tile.height" />

                            </v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-title style="justify-content: center;text-align: left;">{{
                            tile.title
                        }}</v-list-item-title>
                    </v-list-item>
                </v-sheet>
            </v-bottom-sheet>
        </div>





    </div>
</template>

<script>
import apiusers from "../utils/users/apiusers";

import {
    bus
} from "../main";
import apitimesheet from "../utils/timesheet/apitimesheet";

import 'datatables.net'

import 'datatables.net-responsive'

import 'datatables.net-fixedheader'

import '../assets/datatables/dataTables.dataTables.css'
import '../assets/datatables/responsive.dataTables.css'
import '../assets/datatables/fixedHeader.dataTables.css'

import $ from 'jquery';

$.fn.numberFormat = function (decimals = 2, decPoint = ',', thousandsSep = '.') {
    return this.each(function () {
        let raw = $(this).text().trim()

        // Converti da "4.468,20" o "4468,2" a "4468.2"
        let val = raw.replace(/\./g, '').replace(',', '.')

        if (!isFinite(val)) return

        let n = parseFloat(val)
        let fixed = n.toFixed(decimals)

        let parts = fixed.split('.')
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep)
        let formatted = parts.join(decPoint)

        $(this).text(formatted)
    })
}


export default {
    destroyed() {
        this.$root.$children[0].bnavbuttons = [];

        bus.$off("bottomIconClickEvent");
    },

    mounted: function () {
        /*     let self = this;
        fetch('https://jsonplaceholder.typicode.com/posts')
          .then(response => response.json())
          .then(json => self.$data.items = json) */

        //var res = apiprofile.getProfile(1,2);

        /*eslint-disable no-undef*/

        this.$root.$children[0].checkLogout();

        window.curSrcText = "";

        window.myVal = "";

        window.perpage = 50;
        bus.$off("bottomIconClickEvent");


        var pointerVue = this;

        // default value 
        //window.curCompany = "-1";

        var curYear = new Date().getFullYear();
        var curMonth = new Date().getMonth() + 1;

        console.log("CUR YEAR: ", curYear);

        console.log("CUR MONTH: ", curMonth);

        window.curYear = curYear;
        window.curMonth = curMonth;

        window.curStatus = -1; // default tutti

        window.totTimesheet = 0;
        window.totTimesheetForApprove = 0;


        $(document).ready(
            function () {

                $("body").off();

                window.uname = window.$cookies.get("username");
                var uname = window.uname;

                const args = [uname, true, ['bar', 5], {
                    foo: 'baz'
                }];
                try {
                    console.log("entering user");
                    window.flutter_inappwebview.callHandler('setLoggedUser', ...args);
                    console.log("passed");

                } catch (error) {
                    // alert(error);
                }

            }
        );

        $(document).ready(function () {

            $('body').on('click', '.selanno', function () {

                console.log(("EVENTO CLICK SELANNO"));

                pointerVue.sheetAnni = true;

            });


            $('body').on('click', '.selmese', function () {

                console.log(("EVENTO CLICK SELMESE"));

                pointerVue.sheetMesi = true;

            });




            $('body').on('click', '.selazienda', function () {

                console.log(("EVENTO CLICK SELAZIENDA"));

                pointerVue.sheetAziende = true;

            });


            $('body').on('click', '.selaggiorna', function () {

                console.log(("EVENTO CLICK SELAGGIORNA"));

                window.$cookies.set("tot_val_ts", 0, "9y");
                window.$cookies.set("tot_val_open_appr", 0, "9y");

                setTimeout(() => {

                    pointerVue.showSpinner = true;
                    pointerVue.$root.$children[0].showProgress = true;

                    window.table.ajax.reload();

                }, 200);




            });



            $('body').on('click', '.selstato', function () {

                console.log(("EVENTO CLICK SELSTATO"));

                pointerVue.sheetStatus = true;

            });



            $('body').on('click', '#footer-link', function (event) {
                event.preventDefault();

                const args = [1, true, ['bar', 5], {
                    foo: 'baz'
                }];
                window.flutter_inappwebview.callHandler('openLcHandler', ...args);

                return false;
            });

            $('body').on('click', '#privacy-link', function (event) {
                event.preventDefault();

                const args = [1, true, ['bar', 5], {
                    foo: 'baz'
                }];
                window.flutter_inappwebview.callHandler('openPrivacyHandler', ...args);

                return false;
            });

            $('body').on('click', '#hdtool-link', function (event) {
                event.preventDefault();

                const args = [1, true, ['bar', 5], {
                    foo: 'baz'
                }];
                window.flutter_inappwebview.callHandler('openHdHandler', ...args);

                return false;
            });


            $('body').on('click', '.seldata', function (event) {
                console.log(event);


                $(".contpopupdatefrom").show();

                pointerVue.$modal.show('popupDateFrom');



            });

            $('body').on('click', '.btn-cancel-date-from', function (event) {
                console.log(event);

                pointerVue.$modal.hide('popupDateFrom');

            });

            $('body').on('click', '.btn-reset-date-from', function (event) {
                console.log(event);

                pointerVue.dataDa = null;
                pointerVue.dataA = null;


            });


            $('body').on('click', '.btn-confirm-date-from', function (event) {
                console.log(event);

                window.dataDa = pointerVue.dataDa;
                window.dataA = pointerVue.dataA;

                pointerVue.$modal.hide('popupDateFrom');

                pointerVue.showSpinner = true;
                pointerVue.$root.$children[0].showProgress = true;

                window.table.ajax.reload();


            });


            $('body').on('click', '.checkall', function () {


                $(".val_status").prop("checked", $(this).prop("checked"));

                console.log("CHECKALL: ", $(this).prop("checked"));


                if ($(this).prop("checked")) {

                    $("tr").addClass("active-row");

                    $("tr").eq(0).removeClass("active-row");

                }

                if (!$(this).prop("checked")) {

                    $("tr").removeClass("active-row");


                }

                pointerVue.hideShowButtonsSelRow();


            });




        });

        setTimeout(() => {

            this.syncAziende();

        }, 100);


        bus.$on("bottomIconClickEvent", (data) => {
            //this.header = data;
            console.log(data);
            switch (data) {

                case "btn_send":

                    this.validateSend();

                    break;

                default:
                    break;

            }
        });



        this.setupButtonsGrid();


        window.start = 0;

        pointerVue.setupGrid();

        this.hideShowButtons(false);

        setTimeout(() => {

            $('thead th:first div span').addClass('no-before');

            $('#myTable tbody tr td:nth-child(2)').attr('style', 'padding-right:31px !important;');

        }, 500);


    },
    data: () => ({

        sheetFilterStatus: false,

        sheetMesi: false,

        sheetAnni: false,

        anni: [],

        mesi: [],

        valueOtpDelete: "",

        descAziSel: "",

        textSearch: "",

        curSelRow: null,

        dataDa: null,
        showPicker3: false,

        dataA: null,
        showPicker4: false,

        aziende: [],

        search: "",

        sheetAziende: false,


        allStatus: [{
            img: 'keep.png',
            title: 'Open',
            "id": 1,
            icon: "mdi-account-lock-open",
            "color": "red"
        },
        {
            img: 'hangouts.png',
            title: 'To Approve',
            "id": 2,
            icon: "mdi-account-arrow-right",
            "color": "yellow"
        },
        {
            img: 'inbox.png',
            title: 'Closed',
            "id": 3,
            icon: "mdi-account-lock",
            "color": "green"
        },
        ],


        allStatusFilter: [{
            img: '',
            title: 'Tutti',
            "id": 1,
            icon: "mdi-table",
            "color": "black"
        },
        {
            img: 'keep.png',
            title: 'Refused',
            "id": 2,
            icon: "mdi-account-lock-open",
            "color": "red"
        },
        {
            img: 'hangouts.png',
            title: 'to Approve',
            "id": 3,
            icon: "mdi-account-arrow-right",
            "color": "yellow"
        },
        {
            img: 'inbox.png',
            title: 'Approved',
            "id": 4,
            icon: "mdi-account-lock",
            "color": "green"
        },

        {
            img: 'inbox.png',
            title: 'Open',
            "id": 5,
            icon: "mdi-account-lock-open",
            "color": "orange"
        },

        ],





        allFilterStatus: [{
            img: 'https://app.emtool.eu/public/_lib/img/filter_all_easyer.png',
            title: 'Tutti',
            "id": -1,
            icon: "",
            "color": "black",
            height: 28,
            width: 28,
            aSize: "28px",
        },
        {
            img: 'https://app.emtool.eu/public/_lib/img/icon_ts_open_red.png',
            title: 'Open',
            "id": 1,
            icon: "",
            "color": "",
            height: 25,
            width: 25,
            aSize: "25px",
        },


        {
            img: 'https://app.emtool.eu/public/_lib/img/icon_ts_to_approve_yellow.png',
            title: 'To Approve',
            "id": 2,
            icon: "",
            "color": "",
            height: 25,
            width: 25,
            aSize: "25px",
        },


        {
            img: 'https://app.emtool.eu/public/_lib/img/icon_ts_closed_green.png',
            title: 'Closed',
            "id": 3,
            icon: "",
            "color": "",
            height: 25,
            width: 25,
            aSize: "25px",
        },

        {
            img: 'https://app.emtool.eu/public/_lib/img/icon_ts_not_open_gray.png',
            title: 'Not Open',
            "id": 4,
            icon: "",
            "color": "",
            height: 25,
            width: 25,
            aSize: "25px",
        },



        ],







        tiles: [{
            img: 'keep.png',
            title: 'Keep'
        }],



        sheetChangeStatus: false,
        sheetStatus: false,

        currItem: { stato: "" },


        showPicker: false,
        profile: {},
        valid: true,
        initials: "",
        namesurname: "",
        iban: "",
        cellulare: "",
        codicefiscale: "",
        codicefiscaleRules: [
            (v) => !!v || "Codice fiscale is required",
            (v) =>
                (v && v.length <= 16) ||
                "Codice fiscale must be less than 16 characters",
        ],
        cellulareRules: [
            (v) => !!v || "Phone number is required",
            (v) =>
                (v && v.length <= 30) || "Phone number must be less than 15 characters",
        ],
        genRules: [(v) => !!v || "Field required"],
        ibanRules: [
            (v) => !!v || "Iban is required",
            (v) => (v && v.length <= 30) || "Iban must be less than 30 characters",
        ],
        email: "",
        emailRules: [
            (v) => !!v || "E-mail is required",
            (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
        ],
        select: null,
        items: ["Item 1", "Item 2", "Item 3", "Item 4"],
        checkbox: false,





    }),

    computed: {

        filteredAziende() {
            return _.orderBy(this.aziende.filter(item => {
                if (!this.search) return this.aziende;
                return (item.fld_name.toLowerCase().includes(this.search.toLowerCase()));
            }), 'headline')


        },

    },

    methods: {


        validateSend: function () {


            var errore = "";

            if (window.totTimesheetForApprove < window.totTimesheet) {
                errore = "Tutti i timesheet devono essere chiusi";
            }

            if (errore == "") {

                console.log("ok");

                this.sendMailReport();


            }
            else {
                this.$swal({
                    icon: "error",
                    text: errore,
                    showConfirmButton: false,
                    timer: 3000
                });

            }


        },

        sendMailReport: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apitimesheet.sendMailReportTicket(
                v_token,
                window.start,
                window.perpage,
                window.curCompany,
                window.curStatus,
                window.dataDa,
                window.dataA,
                window.curYear,
                window.curMonth,
                window.curSrcText
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from sendMailReportTicket", res);

                that.$swal({
                    icon: "success",
                    text: "Mail inviata correttamente",
                    showConfirmButton: false,
                    timer: 2000
                });


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );


        },


        btnResetSearch: function () {

            window.curSrcText = "";



            this.$modal.hide('popupSearch');

            window.$cookies.set("tot_val_ts", 0, "9y");
            window.$cookies.set("tot_val_open_appr", 0, "9y");


            window.totTimesheet = 0;
            window.totTimesheetForApprove = 0;

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.table.ajax.reload();
        },

        updateHeaderTable: function () {

            if (window.totTimesheet == 0) {

                window.totTimesheet = window.table.rows().count();
            }


            if (window.totTimesheetForApprove == 0) {

                var n_tot_for_approval = 0;

                window.table.rows().every(function () {
                    var rowData = this.data();
                    console.log("Dati della riga:", rowData);

                    var status = rowData.description.toString().toUpperCase();

                    console.log("Dati status:", status);


                    if (status.indexOf("TO APPROVE") !== -1) {
                        n_tot_for_approval = n_tot_for_approval + 1;
                    }

                    if (status.indexOf("CLOSED") !== -1) {
                        n_tot_for_approval = n_tot_for_approval + 1;
                    }

                    return true;
                });

                window.totTimesheetForApprove = n_tot_for_approval;

            }







            var txtAziPeriodo = "";

            pointerVue.$root.$children[0].showAziendaSelezionata = true;
            pointerVue.$root.$children[0].nomeAziendaSelezionata = "";

            if (pointerVue.descAziSel != "") {

                if (pointerVue.descAziSel != "Tutti") {

                    pointerVue.$root.$children[0].nomeAziendaSelezionata = pointerVue.descAziSel;

                }

            }


            var descMonth = "";
            if (window.curMonth == 1) {
                descMonth = "Gennaio";
            }
            if (window.curMonth == 2) {
                descMonth = "Febbraio";
            }
            if (window.curMonth == 3) {
                descMonth = "Marzo";
            }
            if (window.curMonth == 4) {
                descMonth = "Aprile";
            }
            if (window.curMonth == 5) {
                descMonth = "Maggio";
            }
            if (window.curMonth == 6) {
                descMonth = "Giugno";
            }
            if (window.curMonth == 7) {
                descMonth = "Luglio";
            }
            if (window.curMonth == 8) {
                descMonth = "Agosto";
            }
            if (window.curMonth == 9) {
                descMonth = "Settembre";
            }
            if (window.curMonth == 10) {
                descMonth = "Ottobre";
            }
            if (window.curMonth == 11) {
                descMonth = "Novembre";
            }
            if (window.curMonth == 12) {
                descMonth = "Dicembre";
            }

            if (txtAziPeriodo != "") {
                txtAziPeriodo = txtAziPeriodo + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
            }

            txtAziPeriodo = txtAziPeriodo + descMonth + " " + valori.curYear.toString();


            if (txtAziPeriodo != "") {
                txtAziPeriodo = txtAziPeriodo + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
            }


            txtAziPeriodo = txtAziPeriodo + window.totTimesheetForApprove.toString() + " / " + window.totTimesheet.toString();



            $("#infoAziPeriodo").html(txtAziPeriodo);


        },


        filterStatus: function (valore) {


            console.log("STATUS SEL: ", valore);

            this.sheetFilterStatus = false;

            window.curStatus = valore;

            this.hideShowButtons(false);

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.table.ajax.reload();


        },




        filterMese: function (valore) {


            console.log("MESE SEL: ", valore);

            this.sheetMesi = false;

            window.$cookies.set("tot_val_ts", 0, "9y");
            window.$cookies.set("tot_val_open_appr", 0, "9y");


            window.curMonth = valore;

            this.hideShowButtons(false);

            window.curStatus = -1; // default tutti

            window.totTimesheet = 0;
            window.totTimesheetForApprove = 0;

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.table.ajax.reload();


        },



        filterAnno: function (valore) {


            console.log("ANNO SEL: ", valore);

            this.sheetAnni = false;

            window.curYear = valore;

            window.$cookies.set("tot_val_ts", 0, "9y");
            window.$cookies.set("tot_val_open_appr", 0, "9y");


            this.hideShowButtons(false);

            window.curStatus = -1; // default tutti

            window.totTimesheet = 0;
            window.totTimesheetForApprove = 0;

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.table.ajax.reload();

        },


        btnCancelSearch: function () {

            this.$modal.hide('popupSearch');

        },


        btnConfirmSearch: function () {

            console.log("ok");

            window.curSrcText = this.textSearch;

            this.$modal.hide('popupSearch');

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.table.ajax.reload();

        },


        loadLogo: async function () {

            console.log("LOAD LOGO API");

            var token = window.$cookies.get("token");

            try {
                var response = await this.$api
                    .LoadLogoCompanyNew(token, "emtool")
                    .then((res) => {

                        console.log("res LoadLogoCompany: ", res);

                        this.$root.$children[0].pathLogoImage = res.data.UrlLogo;

                        // window.$cookies.set("user_models", res.data.Models, "9y");



                    });
            } catch (error) {
                console.log("err LoadLogoCompany", error);
            }

            console.log(response);



        },






        manageClickAziende: async function (azienda) {

            console.log("AZI SEL: ", azienda);

            this.sheetAziende = false;

            window.curCompany = azienda.companyid;

            window.$cookies.set("sel_filter_azienda_verifica_ts", azienda.companyid, "9y");

            this.hideShowButtons(false);

            window.$cookies.set("tot_val_ts", 0, "9y");
            window.$cookies.set("tot_val_open_appr", 0, "9y");

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;



            var descAzi = "";

            for (var x = 0; x <= this.aziende.length - 1; x++) {

                if (parseInt(this.aziende[x].companyid) == parseInt(azienda.companyid)) {

                    descAzi = this.aziende[x].fld_name;

                }

            }

            console.log("DESC AZI: ", descAzi);

            this.descAziSel = descAzi;

            this.$root.$children[0].nomeAziendaSelezionata = descAzi;

            window.curStatus = -1; // default tutti

            window.totTimesheet = 0;
            window.totTimesheetForApprove = 0;

            window.table.ajax.reload();


        },



        syncAziende: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apiusers.getFilterAziendeNew(
                v_token,
                "emt"
            ).then((res) => {

                that.showSpinner = false;
                that.$root.$children[0].showProgress = false;

                console.log("res from getFilterAziendeNew", res);

                try {

                    this.aziende = res.data.company;

                    var id_azi_sel = window.$cookies.get("sel_filter_azienda_verifica_ts");

                    var descAzi = "";

                    for (var x = 0; x <= this.aziende.length - 1; x++) {

                        if (parseInt(this.aziende[x].companyid) == parseInt(id_azi_sel)) {

                            descAzi = this.aziende[x].fld_name;

                        }

                    }

                    console.log("DESC AZI: ", descAzi);

                    this.descAziSel = descAzi;


                    this.$root.$children[0].showAziendaSelezionata = true;
                    this.$root.$children[0].nomeAziendaSelezionata = descAzi;



                    this.anni = res.data.anni;

                    this.mesi = res.data.mesi;

                } catch (error) {
                    console.log(error);
                }

            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("ERrori", "Non è stato possibile caricare i dati");
                console.log("response", response);

            }

            );

        },

        changeStatus: async function (status) {

            console.log(status);

            this.sheetStatus = false;

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.curStatus = status;

            this.hideShowButtons(false);

            window.table.ajax.reload();


        },




        getUrlDomain: function (nome_metodo) {

            let result = "";

            if (location.hostname == "localhost") {
                result = location.protocol + "//emtool.local/";
            }

            if (location.hostname != "localhost") {

                result = location.protocol + "//" + location.hostname + "/";

            }

            return result + nome_metodo;

        },

        getUrlDomainApi: function (nome_metodo) {

            let result = "";

            if (location.hostname == "localhost") {
                result = location.protocol + "//emtool.local/public/api/";
            }

            if (location.hostname != "localhost") {

                result = location.protocol + "//" + location.hostname + "/api/";

            }

            return result + nome_metodo;

        },


        setupGrid: function () {

            var pointerVue = this;

            var a = window.$cookies.get("a");
            var b = window.$cookies.get("b");

            var filtri = "";

            if (a == 'Y' || a == 'S' || b == 'Y' || b == 'S') {



                filtri = `<div><img src='/emt/img/refresh-emt.png' style='border:0!important;' class='selaggiorna' title='Aggiorna' /></div><div><img src='/emt/img/aziende-emt.png' style='border:0!important;' class='selazienda' title='Aziende' /></div><div><img src='/emt/img/calendario-giorni-emt.png' style='border:0!important;' class='selanno' title='Anno' /></div><div><img src='/emt/img/calendario-mesi-emt.png' style='border:0!important;' class='selmese' title='Mese' /></div><div><img src='/emt/img/filtro-stato-emt.png' style='border:0!important;' class='selstato2' title='Stato' /></div>`;


            }
            else {

                filtri = `<div style="transform: translateY(-1px);margin-left:7px" title='Anno'><ion-select data-id="1" value="` + window.curYear + `" class="selanno" interface="action-sheet" placeholder=" " cancel-text="Chiudi" title='Anno'><ion-select-option value='2020'>2020</ion-select-option><ion-select-option value='2021'>2021</ion-select-option><ion-select-option value='2022'>2022</ion-select-option><ion-select-option value='2023'>2023</ion-select-option><ion-select-option value='2024'>2024</ion-select-option></ion-select></div><div style="transform: translateY(-1px);margin-left:7px" title='Mese'><ion-select data-id="1" value="` + window.curMonth + `" class="selmese" interface="action-sheet" placeholder=" " cancel-text="Chiudi" title='Mese'><ion-select-option value='1'>Gennaio</ion-select-option><ion-select-option value='2'>Febbraio</ion-select-option><ion-select-option value='3'>Marzo</ion-select-option><ion-select-option value='4'>Aprile</ion-select-option><ion-select-option value='5'>Maggio</ion-select-option><ion-select-option value='6'>Giugno</ion-select-option><ion-select-option value='7'>Luglio</ion-select-option><ion-select-option value='8'>Agosto</ion-select-option><ion-select-option value='9'>Settembre</ion-select-option><ion-select-option value='10'>Ottobre</ion-select-option><ion-select-option value='11'>Novembre</ion-select-option><ion-select-option value='12'>Dicembre</ion-select-option></ion-select></div>`;


            }



            $(document).ready(function () {

                var v_token = window.$cookies.get("token");

                window.curCompany = window.$cookies.get("sel_filter_azienda_verifica_ts");



                window.columns = [

                    {
                        data: 'sel_row',
                        orderable: true,
                        searchable: false,
                        name: '',
                        width: '1%',
                    },

                    {
                        data: 'DT_RowIndex',
                        orderable: true,
                        searchable: false,
                        name: '',
                        width: '1%',
                    },

                    {
                        data: 'surname',
                        orderable: true,
                        name: 'surname',
                        width: '4%'
                    },

                    {
                        data: 'name',
                        orderable: true,
                        name: 'name',
                        width: '4%'
                    },

                    {
                        data: 'icon_status',
                        orderable: false,
                        name: 'icon_status',
                        width: '4%'
                    },

                    {
                        data: 'giornate_lav',
                        orderable: true,
                        name: 'giornate_lav',
                        width: '4%'
                    },

                    {
                        data: 'num_ticket',
                        orderable: true,
                        name: 'num_ticket',
                        width: '4%'
                    },

                    {
                        data: 'costo',
                        orderable: true,
                        name: 'costo',
                        width: '4%'
                    },


                ];


                $(".spin").show();





                window.table = $('#myTable').DataTable({
                    // dom: "<'row'<'col-sm-12 col-md-6'l><'col-sm-12 col-md-6'f>>" +
                    //     "<'rows colcontTable'<'col-sm-12 'tr>>" +
                    //     "<'row'<'col-sm-12 col-ok  col-md-12'i><'col-sm-12 col-ok-2  col-md-12'p>>",
                    "pagingType": "simple",
                    responsive: true,
                    "pageLength": window.perpage,

                    processing: false,
                    paging: false,
                    serverSide: false,

                    ajax: {
                        url: pointerVue.getUrlDomain("EmtCheckTimesheetGetTickets") + '?username=' + v_token,
                        data: function (valori) {

                            console.log("VALORI:", valori);

                            try {
                                window.table.clear().draw();

                            } catch (error) {
                                console.log(error);
                            }

                            window.start = window.perpage;

                            valori.start = 0;
                            valori.length = window.perpage;

                            valori.curCompany = window.curCompany;
                            valori.curStatus = window.curStatus;

                            valori.dataDa = window.dataDa;
                            valori.dataA = window.dataA;

                            valori.curYear = window.curYear;
                            valori.curMonth = window.curMonth;

                            valori.curSrcText = window.curSrcText;

                            window.valori = valori;
                            return valori;

                        }

                    },

                    language: {

                        lengthMenu: `<label>Mostra<select name="myTable_length" aria-controls="myTable" class="custom-select custom-select-sm form-control-sm"><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option><option value="-1">Tutti</option></select>Inserimenti</label>`,

                        paginate: {
                            next: "<img style='height:15px;border:none' src='https://app.emtool.eu/_lib/img/next2.png'>",
                            previous: "<img style='height:15px;border:none' src='https://app.emtool.eu/_lib/img/previous2.png'>"
                        },

                        "sSearch": " ",
                        processing: '<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66"><circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg>'
                    },
                    "info": "",
                    "fnDrawCallback": function (oSettings) {

                        console.log(oSettings);

                        $("body").tooltip({
                            selector: '[data-toggle="tooltip"]'
                        });
                    },

                    columns: window.columns,

                    "initComplete": function (settings) {

                        console.log(settings);

                        $("#myTable_wrapper").show();
                        $(".spin").hide();

                    },
                    "drawCallback": function (settings) {

                        console.log(settings);

                        $(".spin").hide();

                        setTimeout(function () {

                            pointerVue.showSpinner = false;
                            pointerVue.$root.$children[0].showProgress = false;

                            var tot1 = window.$cookies.get("tot_val_ts");

                            if (tot1 == 0) {
                                window.$cookies.set("tot_val_ts", window.table.rows().count(), "9y");
                            }
                            else {

                                window.totTimesheet = window.$cookies.get("tot_val_ts");


                            }




                            var n_tot_for_approval = 0;

                            window.table.rows().every(function () {
                                var rowData = this.data();
                                console.log("Dati della riga:", rowData);

                                var status = rowData.description.toString().toUpperCase();

                                console.log("Dati status:", status);


                                if (status.indexOf("TO APPROVE") !== -1) {
                                    n_tot_for_approval = n_tot_for_approval + 1;
                                }

                                if (status.indexOf("CLOSED") !== -1) {
                                    n_tot_for_approval = n_tot_for_approval + 1;
                                }

                                return true;
                            });

                            var tot2 = window.$cookies.get("tot_val_open_appr");


                            if (tot2 == 0) {
                                window.$cookies.set("tot_val_open_appr", n_tot_for_approval, "9y");
                            }
                            else {

                                window.totTimesheetForApprove = window.$cookies.get("tot_val_open_appr");


                            }


                            var descMonth = "";
                            if (window.curMonth == 1) {
                                descMonth = "Gen";
                            }
                            if (window.curMonth == 2) {
                                descMonth = "Feb";
                            }
                            if (window.curMonth == 3) {
                                descMonth = "Mar";
                            }
                            if (window.curMonth == 4) {
                                descMonth = "Apr";
                            }
                            if (window.curMonth == 5) {
                                descMonth = "Mag";
                            }
                            if (window.curMonth == 6) {
                                descMonth = "Giu";
                            }
                            if (window.curMonth == 7) {
                                descMonth = "Lug";
                            }
                            if (window.curMonth == 8) {
                                descMonth = "Ago";
                            }
                            if (window.curMonth == 9) {
                                descMonth = "Set";
                            }
                            if (window.curMonth == 10) {
                                descMonth = "Ott";
                            }
                            if (window.curMonth == 11) {
                                descMonth = "Nov";
                            }
                            if (window.curMonth == 12) {
                                descMonth = "Dic";
                            }



                            var txtDescPeriodo = descMonth + " " + valori.curYear.toString();
                            $("#descPeriodo").html(txtDescPeriodo);

                            var txtCounters = window.totTimesheetForApprove.toString() + " / " + window.totTimesheet.toString();
                            $("#countersSheet").html(txtCounters);


                        }, 1500);






                        var elements = $('.datetimeBook');
                        elements.each(function () {

                            var id = $(this).data("id");
                            (this).pickerOptions = {
                                buttons: [{
                                    text: 'Cancel',
                                    role: 'cancel',
                                    cssClass: 'switch-btn-cancel',
                                },
                                {
                                    text: 'Done',
                                    cssClass: 'switch-btn-done',
                                    handler: columns => {
                                        console.log("ore minuti id", columns.hour.text, columns.minute.text, id);
                                        var valore = columns.hour.text + ":" + columns.minute.text;

                                        console.log(valore);

                                        $.ajax({
                                            url: pointerVue.getUrlDomain("updateHour"),
                                            data: {
                                                "id": id,
                                                "hour": valore,
                                                "v_user": "ZmFnb3N0b25p"
                                            },
                                            success: function () { }
                                        });

                                    }
                                },
                                ],
                            };
                        });

                        setTimeout(function () {

                            //   $("#myTable_filter").width($("#myTable").width());

                        }, 300);

                        var selects = $('.selectstatus');
                        selects.each(function () {
                            var id = $(this).data("id");

                            console.log("ciaone", $(this).data("id"));

                            $(this).on("ionChange", function (opt) {

                                console.log(opt);

                                $(".spin").show();
                                $.ajax({
                                    url: pointerVue.getUrlDomain("updateStatus"),
                                    data: {
                                        "id": id,
                                        "hour": this.value,
                                        "v_user": "ZmFnb3N0b25p"
                                    },
                                    success: function () {
                                        window.table._fnDraw();
                                    }
                                });

                            });

                        });

                        $(".downloadspinner").hide();

                        setTimeout(() => {

                            $("th:first").removeClass("sorting_asc");


                        }, 300);



                        $('.p_costo').numberFormat(2, ',', '.');

                        var costototale = 0;
                        $(".p_costo").each(function () {
                            costototale = costototale + parseFloat($(this).text().replace(".", "").replace(",", "."));
                        });

                        $("#v_tot_costo").text(costototale.toString().replace(".", ","));
                        $('#v_tot_costo').numberFormat(2, ',', '.');

                        setTimeout(() => {


                            $('#myTable tbody tr td:nth-child(2)').attr('style', 'padding-right:31px !important;');

                        }, 500);

                    }

                });




                //Events
                //START SETUP
                function throttle(f, delay) {
                    var timer = null;
                    return function () {
                        var context = this,
                            args = arguments;
                        clearTimeout(timer);
                        timer = window.setTimeout(function () {
                            f.apply(context, args);
                        },
                            delay || 500);
                    };
                }
                window.loading = 0;
                $("div.dataTables_filter input").unbind();
                $('div.dataTables_filter input').keyup(throttle(function () {
                    window.table.ajax.reload();

                }));
                $('#myTable_wrapper').on('scroll', function () {
                    if ($(this).scrollTop() + $(this).innerHeight() + 50 >= $(this)[0].scrollHeight) {
                        if (window.loading == 0) {
                            $(".spin").show();

                            setTimeout(() => {

                                $(".spin").hide();
                                window.loading = 0;

                            }, 500);


                        }
                        window.loading = 1;
                    }
                });
                //END

                var search = $(".dataTables_length").clone(true);
                search.attr("id", "final_search");
                $(".table_paginate").prepend(search);

                $("#myTable_wrapper .dt-layout-row").first().find("div").remove();

                $("#myTable_wrapper .dt-layout-end").remove();

                $("#myTable_wrapper .dt-layout-row").first().prepend(`

                <div style="display:table">
                    
                    <div style="display:table-row">

                        <div style="display:table-cell">
                        
                            <div class="cont_buttons">

                                <div class="text_title">Ticket</div>
                                


                                </div>
                        
                            </div><div style="display:flex; justify-items: center;
    align-items: center; transform: translateY(9px);">` + filtri + `</div>


                    </div>

                    <div style="display:table-row">

                        <div style="display:table-cell">
                            <div style="display:flex;margin-left:10px; transform: translateY(-6px);">
                                <div style="font-weight:bold;font-size:9px;width:55px;text-align:left" id="descPeriodo"></div>
                                <div style="font-weight:bold;font-size:9px;width:47px;text-align:right" id="countersSheet"></div>
                            </div>
                        </div>
                        
                    </div>


                </div>

           


                <div><img src='/emt/img/cerca-emt.png' style='border:0!important;' class='selricerca' title='Ricerca' /></div>

            `);

                $(".selricerca").on("click", function (opt) {
                    console.log(opt);

                    pointerVue.textSearch = "";

                    $(".contpopupsearch").show();

                    pointerVue.$modal.show('popupSearch');

                });

                $('body').on('click', '.paginate_button', function () {
                    $(".spin").show();

                });

                $('body').on('click', '.refreshButton', function () {

                    $(".spin").show();
                    window.table._fnDraw();

                });


                $(".selectstatusall").on("ionChange", function (opt) {
                    console.log(opt);
                    $(".spin").show();
                    window.curStatus = this.value;



                    window.table.ajax.reload();

                });


                $('body').on('click', '.cont_ticket_res_ok tr', function () {

                    var row_data = window.table.row(this).data();

                    if (row_data != null) {


                        console.log("DATA ROW: ", row_data);

                        pointerVue.curSelRow = row_data;


                        var last_id_sel = $("tr.active-row").find(".id_row").attr("data-id");

                        var id_sel = $(this).find(".id_row").attr("data-id");

                        //$("tr").removeClass("active-row");

                        var set_cls_active = 0;

                        if (last_id_sel == "undefined") {
                            set_cls_active = 1;
                        } else {
                            if (last_id_sel != id_sel) {
                                set_cls_active = 1;
                            }
                        }

                        console.log("ROM IS ACTIVE: ", set_cls_active);



                        console.log("THIS: ", this);

                        var hasClassActive = $(this).hasClass("active-row");

                        if (hasClassActive) {

                            console.log("ACTIVE-ROW");

                            $(this).find(".val_status").prop("checked", false);

                            $(this).removeClass("active-row");

                        }

                        if (!hasClassActive) {

                            console.log("NOT ACTIVE-ROW");

                            $(this).find(".val_status").prop("checked", true);

                            $(this).addClass("active-row");



                        }

                        window.id_par_sel = $("tr.active-row").find(".id_row").attr("data-id");

                        if (window.id_par_sel == undefined) {
                            window.id_par_sel = id_sel;
                        }

                        console.log("ID SELECTED: ", window.id_par_sel);

                        pointerVue.hideShowButtonsSelRow();


                    }




                });


                $(".selstato2").on("click", function (opt) {

                    console.log(opt);

                    pointerVue.sheetFilterStatus = true;


                });


                // $(".selstato2").on("ionChange", function (opt) {
                //     console.log(opt);

                //     console.log("VALUE STATO: ", this.value)

                //     window.curStatus = this.value;

                //     pointerVue.hideShowButtons(false);

                //     pointerVue.showSpinner = true;
                //     pointerVue.$root.$children[0].showProgress = true;

                //     window.table.ajax.reload();



                // });





                window.parentiAddedEvents = true;

            });

        },


        hideShowButtonsSelRow: function () {


            setTimeout(() => {



                this.$root.$children[0].bnavbuttons = [];



            }, 100);



        },






        hideShowButtons: async function (v_enable) {

            setTimeout(() => {



                console.log(v_enable);

                var pulsantis = [];

                pulsantis.push(

                    {
                        text: "Invia Report",
                        icon: "mdi-arrow-left",
                        image: this.getUrlDomain("public/_lib/img/mail_log_emt.png"),
                        link: "/confOrariChoice",
                        id: "btn_send",
                        disabled: false,
                        title: "Invia Report",
                        width: 35
                    }



                );

                this.$root.$children[0].bnavbuttons = pulsantis;

            }, 100);

        },

        setupButtonsGrid: async function () {
            setTimeout(() => {
                // console.log ("here we go" , this.$root.$children[0].drawer ) ;
                //window.App.$children[0].setToolbar();
                //   this.$root.$children[0].setToolbar();

                var pulsantis = [

                    {
                        text: "Add",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/xbox-cross-emt.png",
                        link: "/settings",
                        id: "btn_add",
                        disabled: false,
                        width: 30
                    },

                    {
                        text: "Edit",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/icon_edit_emt.png",
                        link: "/info",
                        id: "btn_edit",
                        disabled: false,
                        width: 30
                    },

                    {
                        text: "Delete",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/icon_delete_emt.png",
                        link: "/info",
                        id: "btn_delete",
                        disabled: false,
                        width: 30
                    },

                    {
                        text: "Dashboard",
                        icon: "mdi-home-circle",
                        link: "/dash",
                        id: "btn_exit",
                        disabled: false,
                    },

                ];
                //window.App.$children[0].bnavbuttons = pulsantis;
                this.$root.$children[0].bnavbuttons = pulsantis;

                setTimeout(() => {

                }, 100);

            }, 100);
        },

        setupButtons: async function () {
            setTimeout(() => {
                // console.log ("here we go" , this.$root.$children[0].drawer ) ;
                //window.App.$children[0].setToolbar();
                //   this.$root.$children[0].setToolbar();

                var pulsantis = [

                    {
                        text: "Dashboard",
                        icon: "mdi-home-circle",
                        link: "/qrconfirm",
                        id: "btn_qrcode",
                        image: "https://app.smart-book.it/public/smartbook/ICON_3.png",
                        disabled: false,
                    },

                    {
                        text: "Settings",
                        icon: "mdi-home-circle",
                        image: "https://app.smart-book.it/public/_lib/img/icons8-settings-64.png",
                        class: "inverted",
                        link: "/settings",
                        id: "btn_settings",
                        disabled: false,
                    },

                    {
                        text: "Info",
                        icon: "mdi-home-circle",
                        image: "https://app.smart-book.it/public/_lib/img/icons8-informazioni-482.png",
                        class: "inverted",
                        link: "/info",
                        id: "btn_info",
                        disabled: false,
                    },

                    {
                        text: "Pdf",
                        icon: "mdi-home-circle",
                        image: "https://app.smart-book.it/public/_lib/img/sb-export-pdf-50.png",
                        class: "inverted",
                        link: "/pdf",
                        id: "btn_pdf",
                        disabled: false,
                    },

                ];

                //window.App.$children[0].bnavbuttons = pulsantis;
                this.$root.$children[0].bnavbuttons = pulsantis;

                setTimeout(() => {

                }, 100);

            }, 100);
        },

        syncProfile: async function () {
            /*  var token = window.$cookies.get("token");
            var system = window.$cookies.get("system"); */

            //  this.data.days = response.data ;
        },

        btn_add_tms_click() {
            console.log(1);
        },
        /*          onClick() {
      console.log('a phone number was clicked');
    }
,
 */
        reply(par) {
            console.log(par);
        },

        reset() {
            this.$refs.form.reset();
        },
        resetValidation() {
            this.$refs.form.resetValidation();
        },




    },
};
</script>

<style scoped>
.titlenewrow {
    justify-content: center;
    padding-top: 25px;
    padding-bottom: 30px;
    font-weight: bolder;
}

.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none;
}
</style>

<style>
.no-before::before {
    content: none !important;
}


table.dataTable.dtr-inline.collapsed>tbody>tr>td.dtr-control:before,
table.dataTable.dtr-inline.collapsed>tbody>tr>th.dtr-control:before {
    margin-right: 0.5em !important;
    display: block !important;
    box-sizing: content-box !important;
    content: "+" !important;
    color: white !important;
    top: 50% !important;
    left: 5px !important;
    height: 1em !important;
    width: 1em !important;
    margin-top: -9px !important;
    border: .15em solid white !important;
    border-radius: 1em !important;
    box-shadow: 0 0 .2em #444 !important;
    text-align: center !important;
    text-indent: 0 !important;
    font-family: "Courier New", Courier, monospace !important;
    line-height: 1em !important;
    background-color: #a4a4b0 !important;
    transform: translate(0px, 0px) !important;
}


.cont_ticket_res_ok #myTable_wrapper>.dt-layout-row:first-of-type {
    top: 66px;
    position: fixed;
    left: 0px;
    min-width: 100%;
    z-index: 3;
    background-color: white;
    border: 1px solid #ffd212;
    padding-left: 3px;
    padding-right: 3px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-top: 0px;
}


.cont_ticket_res_ok .col_footer {
    padding-top: 15px !important;
    padding-bottom: 5px !important;
    padding-left: 6px;
    border-top: 1px solid black
}

.cont_ticket_res_ok .col_footer_right {
    padding-top: 15px !important;
    padding-bottom: 5px !important;
    padding-left: 6px;
    border-top: 1px solid black;
    text-align: right;
    padding-right: 6px;
}


#fldValueOtpDelete {
    text-align: center;
    font-size: 20px
}

.cl-cliente-ver-ts {
    font-size: 8px;
    width: 100px;
}

.cl-test {
    transform: translate(-994px, 16px);
}

.cl-table {
    display: table;
}

.cl-row {
    display: table-row;
}

.cl-cell {
    display: table-cell
}

.cl-cell-filtri {
    display: table-cell;
    width: 200px
}

.cl-cell-azi {
    display: block;
    transform: translate(-291px, 18px);
}

.cl-cell-title {

    display: block;
    min-width: 93px;
}

.dataTable tbody tr,
.dataTable tbody tr td {
    vertical-align: middle;
    padding: 6px !important;
}

.pay {
    display: flex;
    justify-content: center;
    padding-top: 10px;
    color: #f5cf2e;

}

.pay a {
    color: #f5cf2e;

    -webkit-transition: background-color 2s ease-out;
    -moz-transition: background-color 2s ease-out;
    -o-transition: background-color 2s ease-out;
    transition: background-color 2s ease-out;

}

.pay a:hover {
    color: #f5cf2e;
}

.plan {
    margin-top: 20px;
    font-size: 12px;
    display: flex;
    justify-content: center;

}

.policy {
    text-align: center;
    margin-top: 30px;
}

.version {
    font-size: 10px;
    margin-top: 25px;
    text-align: center;
}

.version span {
    font-size: 13px;
}

.titleproduct {
    font-size: 16px;
    font-size: 16px;
    color: #rgb(245, 207, 46);
    font-weight: 800;

    text-align: center;
    margin-top: 40px;

}

.Absolute-Center {

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    bottom: 0;
    height: 100px;
    left: 0;
    margin: auto;
    position: absolute;
    top: 0;
    right: 0;
    width: 300px;
}

.logo {
    text-align: center;
}


ion-items {
    min-width: 60px;

}

ion-items ion-datetime {
    margin-left: 25px;
}

.colcontTable .col-sm-12 {
    padding:
        0px;
}

.selectpianiall {
    max-width: 21px;
    min-height: 22px;
    margin-left: 0px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    /* border-radius: 12px; */
    /* min-height: 12px; */
    /* transform: translateY(-2px); */
    background-image: url(/smartb/img/FiltroNucleo.png);
    /* padding: 1px 11px; */
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    transform: translateY(2px);
}


.cont-table .spin {

    display: flex;
    position: absolute;
    z-index: 100;
    min-width: 100vw;
    min-height: 100vh;
    left: 0;
    top: 0;
    align-items: center;
    justify-content: center;
}

.cont_ticket_res_ok #myTable {
    margin-right: 3px;
}

.cont_ticket_res_ok table.dataTable.dtr-inline.collapsed>tbody>tr>td.dtr-control,
.cont_ticket_res_ok table.dataTable.dtr-inline.collapsed>tbody>tr>th.dtr-control {
    padding-left: 25px !important;
    padding-bottom: 9px !important;
}

.cont_ticket_res_ok th {
    padding-left: 5px !important;
}

.cont_ticket_res_ok ion-datetime.dateBook {
    margin-left: 16px;
}

.cont_ticket_res_ok .table-responsive {
    padding: 0px;
    min-width: 90vw;
    max-width: 100vw;
}


.cont_ticket_res_ok #myTable_filter {
    position: fixed;
    left: 0px;
    min-width: 100%;
    z-index: 3;
    background-color: white;
    border-color: #f5cf2e;

}

.cont_ticket_res_ok div.dataTables_wrapper div.dataTables_filter input {
    /* margin-top:5px!important */
}

.cl-date {
    font-size: 10px;
    color: gray;
}

/* .cont_ticket_res_ok #myTable_wrapper {
    padding-top: 0px;
    min-width: initial;
    max-width: 1000px;
    width: 1000px;
} */

.cont_ticket_res_ok #myTable_wrapper {
    padding-top: 0px;
    min-width: 900px;
    max-width: 900px;
    width: 900px;
}

.cont_ticket_res_ok .text_title {
    background-color: white;
    color: black;
    font-weight: bold;
    padding-top: 4px;
    padding-bottom: 4px;
    padding-left: 0px;
    font-size: 10px;
    min-width: 0vw;
}

.cont_ticket_res_ok .cl_active {
    display: inline-flex;
    align-items: center;
    min-width: 100%;
    justify-content: center;
}

.cont_ticket_res_ok .selectstatusall {
    max-width: 21px;
    min-height: 22px;
    margin-left: 0px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    background-image: url(/emt/img/Filtro.png);
    text-indent: -119px;
    background-size: 24px !important;
    background-repeat: no-repeat;
    transform: translateY(2px);
    margin-top: -5px !important;

}


.cont_ticket_res_ok .cont_buttons {
    display: flex !important;
    align-items: center !important;
    float: left !important;
    min-width: 95px !important;
    padding-left: 10px !important;
    justify-content: inherit !important;
}

.action-sheet-button-inner.sc-ion-action-sheet-ios {
    color: black !important;
}

.closeStatusSheet {
    position: absolute;
    right: 0;
}

.selstato {
    max-width: 23px;
    min-height: 23px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;

}

/* .cont_ticket_res_ok #myTable {
    margin-right: 3px;
    width: 985px !important;
} */

.cont_ticket_res_ok #myTable {
    margin-right: 3px;
    width: 885px !important;
}


.cont_ticket_res_ok .selazienda {
    max-width: 24px;
    min-height: 24px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 24px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
}

.cont_ticket_res_ok .selaggiorna {
    max-width: 22px;
    min-height: 22px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
}


.headerSheetAziende {
    position: fixed;
    z-index: 2;
    min-width: 100vw;
    background: white;
}


.itemAzienda {
    margin-left: 15px;
}

.v-application .text-center {

    overflow: auto;
}

.cont_ticket_res_ok .clDataDa {
    font-weight: bold;
    transform: translate(6px, -12px);
}

.cont_ticket_res_ok .clValueDataDa {
    font-weight: bold;
    transform: translate(11px, -11px);
}

.cont_ticket_res_ok .seldata {
    max-width: 22px;
    min-height: 22px;
    margin-left: 11px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
    margin-top: --2px;
}


.cont_ticket_res_ok .cl_checkall {
    padding-left: 1px;
    padding-top: 2px;
}

.cont_ticket_res_ok .checkall {
    width: 13px;
    height: 13px;
}

.cont_ticket_res_ok .val_status {
    width: 10px !important;
}

.cont_ticket_res_ok .selanno {
    max-width: 24px !important;
    min-height: 27px !important;
    margin-left: 2px !important;
    color: black !important;
    padding: 0px 0px !important;
    min-width: 22px !important;
    text-indent: -119px !important;
    background-size: 27px !important;
    z-index: 2 !important;
    border: none !important;
    cursor: pointer !important;
    margin-top: 2px !important;
}

.cont_ticket_res_ok .selmese {
    max-width: 24px !important;
    min-height: 27px !important;
    margin-left: 2px !important;
    color: black !important;
    padding: 0px 0px !important;
    min-width: 22px !important;
    text-indent: -119px !important;
    background-size: 27px !important;
    z-index: 2 !important;
    border: none !important;
    cursor: pointer !important;
    margin-top: 2px !important;
}

.cont_ticket_res_ok .selstato2 {
    max-width: 24px !important;
    min-height: 24px !important;
    margin-left: 2px !important;
    color: black !important;
    padding: 0px 0px !important;
    min-width: 24px !important;
    text-indent: -119px !important;
    background-size: 24px !important;
    z-index: 2 !important;
    border: none !important;
    cursor: pointer !important;
    margin-top: 2px !important;
}


.cont_ticket_res_ok .selricerca {
    max-width: 31px;
    min-height: 31px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
    margin-right: 14px !important;
    float: right;
}



.cl-ordinario {
    width: 100% !important;
    text-align: center !important
}

.cl-reperibilita {
    width: 100% !important;
    text-align: center !important
}

.cl-intervento {
    width: 100% !important;
    text-align: center !important
}


.cl-ordinario-green-ver-ts {
    width: 47px !important;
    text-align: center !important;
    border: 2px solid forestgreen;
    min-height: 20px;
    vertical-align: middle;
    padding-top: 3px;
    margin-top: -3px;
    min-width: 47px !important;
    max-width: 47px !important;
}



.cl-straordinario {
    width: 100% !important;
    text-align: center !important
}


.cl-straordinario-blue-ver-ts {
    width: 47px !important;
    text-align: center !important;
    border: 2px solid dodgerblue;
    min-height: 20px;
    vertical-align: middle;
    padding-top: 3px;
    margin-top: -3px;
    min-width: 47px !important;
    max-width: 47px !important;
}



.cl-activity-ver-ts {
    width: 60px !important;
    text-align: center !important;
    /* margin-left: 14px; */
}

.cl-activity-red-ver-ts {
    width: 47px !important;
    text-align: center !important;
    border: 2px solid red;
    min-height: 20px;
    vertical-align: middle;
    padding-top: 3px;
    margin-top: -3px;
    /* margin-left: 8px; */
    min-width: 47px !important;
    max-width: 47px !important;
}


.cl-total {
    width: 100% !important;
    text-align: center !important
}

.p_total_hour,
.p_total_hour_worked,
.p_total_hour_office,
.p_total_hour_smartworking,
.p_reperibilita,
.p_intervento {
    width: 100% !important;
    text-align: center !important
}

.cl-progetti {
    text-align: center;
}

.cont_ticket_res_ok .azienda_selezionata {
    font-weight: bold;
    transform: translate(-980px, 16px);
    font-size: 9px;
}

@media screen and (max-width: 960px) {

    .cl_note {
        display: inline;
    }

    .cont_ticket_res_ok .cl_active {
        display: contents;
        align-items: center;
        justify-content: flex-start;
        text-align: center;
    }

    .cont_ticket_res_ok #myTable {
        /* margin-top:54px; */
    }

    .cont_ticket_res_ok #myTable_filter {
        top: 56px;
        position: fixed;

    }

}

@media screen and (max-width: 1024px) {

    .contIcon {
        display: inherit;
    }



    .cont_ticket_res_ok #myTable {
        max-width: 100vw !important;
        margin-right: 0px;
        min-width: 100vw !important;
        position: relative;
        width: 100vw !important;

    }

    .cont_ticket_res_ok #myTable_filter {
        top: 56px;
        position: fixed;

    }

    .cont_ticket_res_ok .table-responsive {
        padding: 0px;
        min-width: 95vw !important;
        max-width: 95vw !important;
        left: 0px;
        position: fixed;

    }

    .cont_ticket_res_ok #myTable_wrapper {
        min-width: initial;
        min-width: 100vw !important;
        max-width: 100vw !important;
        width: 100vw !important;
        overflow-x: auto !important;
    }

    .cont_ticket_res_ok .cl_num {
        margin-left: -3px !important;
    }

    .cl_n_matricola {
        display: inline-flex;
    }

    .cl_desc_project {
        display: inline-flex;
    }

    .cl_costo_giornaliero {
        display: inline-flex;
    }

    .cl_diaria {
        display: inline-flex;
    }

    .cl_ticket {
        display: inline-flex;
    }

    .cl_piano_orario {
        display: inline-flex;
    }

    .cl_ebadge {
        display: inline-flex;
    }

    .cl_totale_ferie {
        display: inline-flex;
    }

    .cont_ticket_res_ok .cl_checkall {
        padding-left: 2px;
        padding-top: 2px;
    }


    .cl-ordinario {
        width: 100% !important;
        text-align: center !important;
        display: inline;
        padding-left: 20px;
        padding-right: 20px
    }

    .cl-ordinario-green-ver-ts {
        width: 47px !important;
        text-align: center !important;
        border: 2px solid forestgreen;
        min-height: 20px;
        vertical-align: middle;
        padding-top: 3px;
        margin-top: -3px;
        min-width: 47px !important;
        max-width: 47px !important;
    }

    .cl-straordinario {
        width: 100% !important;
        text-align: center !important;
        display: inline;
        padding-left: 20px;
        padding-right: 20px
    }

    .cl-straordinario-blue-ver-ts {
        width: 47px !important;
        text-align: center !important;
        border: 2px solid dodgerblue;
        min-height: 20px;
        vertical-align: middle;
        padding-top: 3px;
        margin-top: -3px;
        min-width: 47px !important;
        max-width: 47px !important;
    }

    .cl-activity {
        width: 100% !important;
        text-align: center !important;
        display: inline;
        padding-left: 20px;
        padding-right: 20px
    }

    .cl-activity-red {
        width: 100% !important;
        text-align: center !important;
        border: 2px solid red;
        min-height: 20px;
        vertical-align: middle;
        padding-top: 3px;
        margin-top: -3px;
        display: inline;
        padding-left: 20px;
        padding-right: 20px
    }


    .cl-total {
        width: 100% !important;
        text-align: center !important;
        display: inline
    }

    .p_total_hour,
    .p_total_hour_worked,
    .p_total_hour_office,
    .p_total_hour_smartworking {
        width: 100% !important;
        text-align: center !important;
        display: inline
    }


    .cl-progetti {
        text-align: center;
        display: inline;
    }

    .cl-test {
        transform: translate(-273px, 16px);
    }

    .cont_ticket_res_ok .azienda_selezionata {
        font-weight: bold;
        transform: translate(-273px, 16px);
        font-size: 9px;
    }

    .cont_ticket_res_ok #myTable_wrapper>.dt-layout-row:first-of-type {
        top: 66px;
        position: fixed;
        left: 0px;
        min-width: 100%;
        z-index: 3;
        background-color: white;
        border: 1px solid #ffd212;
        padding-left: 3px;
        padding-right: 3px;
        padding-top: 10px;
        padding-bottom: 10px;
        margin-top: -9px;
    }



}
</style>
